import { Tab, Tabs as MUITabs } from '@mui/material'
import React from 'react'
import { translate } from 'utils/propKeysTranslations'

const RoleTabs = ({
  setTab, tab, children, options,
}) => {
  return (
    <>
      <MUITabs
        sx={{ borderBottom: 1, borderColor: 'divider', alignSelf: 'stretch' }}
        value={tab}
        onChange={(_e, newValue) => {
          setTab(newValue)
        }}
        textColor='secondary'
        indicatorColor='secondary'
        variant='scrollable'
      >
        {options.map((r) => (
          <Tab key={r.mainPath} value={r} label={translate(r.role)} />
        ))}
      </MUITabs>
      {children}
    </>
  )
}

export default RoleTabs
